module.exports = __webpack_public_path__ + "img/empty-barmen.0f138f8.svg";